import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { eForceUpdate } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { useAfterDidMountEffect } from 'src/tools/customHooks';

//import { instanceType, AllTypes } from 'src/tools/helper';
const switchUuidHooks = ({ uuid }) => {
  const _h = useHistory();
  const _params: any = useParams();
  const { uuid: sUuid, tagUuid } = _params;

  useAfterDidMountEffect(() => {
    if (uuid !== tagUuid && uuid) {
      _h.push({
        pathname: `/salesChannel/promotionTag/editor/${sUuid}/${uuid}`,
        state: {
          skipNotice: true,
        },
      });
      // console.log('uuid switch');
      eForceUpdate(uuid);
    }
  }, [uuid]);
};
export { switchUuidHooks };
